export const LEVEL = {
  COURSE: 'COURSE',
  SECTION: 'SECTION',
  SUBSECTION: 'SUBSECTION',
};
